/* import __COLOCATED_TEMPLATE__ from './role-cell.hbs'; */
/* RESPONSIBLE TEAM: team-email */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */

import InviteBaseCell from 'embercom/components/table-cells/invite-list/base-cell';

export default class RoleCell extends InviteBaseCell {
  get inviteConfiguration() {
    return this.row.advancedInviteConfiguration;
  }

  get role() {
    if (this.inviteConfiguration && this.inviteConfiguration.role) {
      return this.inviteConfiguration.role;
    } else {
      return '-';
    }
  }
}
